import { useEffect, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import Spinner from "../../../components/ui/Spinner";

export default function Logout() {
  const { user } = useSelector((state: RootState) => state.auth);
  const [redirecting, setRedirecting] = useState(true);

  // Function to clear stored user data
  const clearUserData = useCallback(() => {
    localStorage.removeItem("user");
    sessionStorage.removeItem("currentUserId");
    sessionStorage.removeItem("copyMasterButtonModalShow");
    sessionStorage.removeItem("currentSelectedClient");
  }, []);

  useEffect(() => {
    const logout = async () => {
      try {
        clearUserData();
        const redirectUrl =
          user?.logoutURL || localStorage.getItem("userLoginUrl") || "/";
        window.location.replace(redirectUrl);
      } catch (error) {
        console.error("Logout error:", error);
        setRedirecting(false); // Stop redirecting if an error occurs
      }
    };

    logout();
  }, [user, clearUserData]);

  if (!redirecting) {
    return (
      <div
        style={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h3>Logout failed. Please try again.</h3>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: "var(--font-lg)",
        }}
      >
        <Spinner />
        <h3>Signing you out...</h3>
      </div>
    </div>
  );
}
